/*!
 * Copyright (c) 2026 Elevation Technologies Pte Ltd.
 * Developer: filimoni@elevationtech.com.fj
 */
export function htmlToText(value = '') {
  if (typeof document === 'undefined') {
    return String(value).replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
  }

  const node = document.createElement('div');
  node.innerHTML = value;
  return node.textContent.replace(/\s+/g, ' ').trim();
}

export function getPostImage(post) {
  const media = post?._embedded?.['wp:featuredmedia']?.[0];
  const sizes = media?.media_details?.sizes || {};
  return sizes.medium_large?.source_url || sizes.large?.source_url || sizes.full?.source_url || media?.source_url || '';
}

export function getPlainHtmlText(html = '') {
  return html
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;|\u00a0/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();
}

export function isImportedFooterBlock(block) {
  if (block?.type !== 'html') {
    return false;
  }

  const text = getPlainHtmlText(block.html);

  if (!text) {
    return true;
  }

  if (text.includes('freight services (fiji) pte limited')) {
    return true;
  }

  return ['privacy policy', 'anti bribery', 'anti trust', 'disclaimer'].every((term) => text.includes(term));
}
